import React from 'react';
import { financialProjections } from '../../data/mock';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';

const FinancialProjections = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Your Path to $6,000+ Monthly Income
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Conservative estimates based on 2025 market data
          </p>
        </div>

        {/* Financial Table */}
        <div className="max-w-5xl mx-auto">
          <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-lg">
            <Table>
              <TableHeader>
                <TableRow className="bg-teal-500 hover:bg-teal-500">
                  <TableHead className="text-white font-bold text-lg py-5">Timeline</TableHead>
                  <TableHead className="text-white font-bold text-lg py-5 text-center">Turo</TableHead>
                  <TableHead className="text-white font-bold text-lg py-5 text-center">Turno</TableHead>
                  <TableHead className="text-white font-bold text-lg py-5 text-center">Roomster</TableHead>
                  <TableHead className="text-white font-bold text-lg py-5 text-center">Total</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {financialProjections.map((row, idx) => (
                  <TableRow 
                    key={idx} 
                    className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                  >
                    <TableCell className="font-semibold text-gray-900 text-base py-5">
                      {row.timeline}
                    </TableCell>
                    <TableCell className="text-center text-gray-700 text-base py-5">
                      {row.turo}
                    </TableCell>
                    <TableCell className="text-center text-gray-700 text-base py-5">
                      {row.turno}
                    </TableCell>
                    <TableCell className="text-center text-gray-700 text-base py-5">
                      {row.roomster}
                    </TableCell>
                    <TableCell className="text-center font-bold text-teal-600 text-lg py-5">
                      {row.total}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>

          {/* Note */}
          <p className="text-center text-gray-500 mt-6 text-sm">
            * Conservative estimates based on 2025 market data. Individual results may vary.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinancialProjections;
